exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "/*\n  Stylesheet for the event recommendations page\n  @author Eduardo Parducci, Andrea Villeda\n*/\n.no-link[data-v-1143b597] {\n    text-decoration: none !important;\n}", "", {"version":3,"sources":["/home/gitlab-runner/builds/3bb37404/0/mkz/werner-frontend/src/components/company/profile/events/events.css"],"names":[],"mappings":"AAAA;;;EAGE;AAEF;IACI,iCAAiC;CAClC","file":"events.css","sourcesContent":["/*\n  Stylesheet for the event recommendations page\n  @author Eduardo Parducci, Andrea Villeda\n*/\n\n.no-link {\n    text-decoration: none !important;\n  }"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1143b597","scoped":true,"hasInlineConfig":false}!./src/components/company/profile/events/events.css
// module id = V9Ta
// module chunks = 1